import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./theme/ThemeProvider";
import { AuthProvider } from "./features/auth/context/AuthContext";
import { ProtectedRoute } from "./features/auth/components";
import { queryClient } from "./utils/queryClient";
import {
  Login,
  Signup,
  ForgotPassword,
  VerifyEmail,
  ResetPassword,
} from "./pages/Auth";
import { Dashboard } from "./pages/Dashboard";
import { IntegrationsCallback } from "./pages/IntegrationsCallback";
import { NotFound } from "./pages/NotFound";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultMode="light">
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/home/*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/integrations/callback" element={<IntegrationsCallback />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontFamily:
                '"Base Neue Trial", Roboto, Helvetica, Arial, sans-serif',
            },
          }}
        />
      </AuthProvider>
    </ThemeProvider>
    </QueryClientProvider>
  );
}
